export abstract class ImageProcessorConfig {
  abstract options: {
    width: string;
    height: string;
    anchor: string;
    mode: string;
    format: string;
    quality: string;
    scale: string;
    other: string;
  };

  parseAnchor(
    anchor:
      | 'topleft'
      | 'topcenter'
      | 'topright'
      | 'middleleft'
      | 'middlecenter'
      | 'middleright'
      | 'bottomleft'
      | 'bottomcenter'
      | 'bottomright'
  ): string {
    return anchor;
  }
}

export enum ImageProcessor {
  ImageFlow = 0,
  ImageSharp = 1,
}

export const ImageFlowConfig: ImageProcessorConfig = {
  options: {
    width: 'width',
    height: 'height',
    anchor: 'anchor',
    mode: 'mode',
    format: 'format',
    quality: 'quality',
    scale: 'scale',
    other: 'other',
  },
  parseAnchor: anchor => {
    return anchor;
  },
};

export const ImageSharpConfig: ImageProcessorConfig = {
  options: {
    width: 'width',
    height: 'height',
    anchor: 'ranchor',
    mode: 'rmode',
    format: 'format',
    quality: 'quality',
    scale: 'scale',
    other: 'other',
  },

  parseAnchor: anchor => {
    switch (anchor) {
      case 'topleft':
        return anchor;
      case 'topcenter':
        return 'top';
      case 'topright':
        return anchor;
      case 'middleleft':
        return 'left';
      case 'middlecenter':
        return 'center';
      case 'middleright':
        return 'right';
      case 'bottomleft':
        return anchor;
      case 'bottomcenter':
        return 'bottom';
      case 'bottomright':
        return anchor;
      default:
        return anchor;
    }
  },
};

export const defaultConfig = ImageFlowConfig;
